<div class="component-main-container" [class.editable-layout]="csvModel === 'editable'">
  <app-page-header parentTitle="{{'imports-csv.parentTitle' | translate}}"
    pageTitle="{{'import-service-order.page-title' | translate}}">
  </app-page-header>
  <div class="component-forms-box">
    <div class="form-fields-box">
      <div class="import-title">
        <h2> {{'import-service-order.imports-service-order-title' | translate}} </h2>
        <button pButton icon="pi pi-question-circle" class="p-button-rounded btn-send-file"
          label="{{'import-service-order.see-instructions' | translate}}" (click)="visibleInstructions = true">
        </button>
      </div>
      <div class="import-container" *ngIf="csvModel !== 'editable'">
        <p-card header="{{'import-service-order.import-file-title' | translate}}">
          <p-fileUpload chooseLabel="{{'import-service-order.select-button' | translate}}" chooseStyleClass="btn-select"
            accept=".csv" [showUploadButton]="false" [showCancelButton]="false" [customUpload]="true"
            (onSelect)="getFile($event)" (onClear)="onFileClear()" (onRemove)="onFileClear()">
            <ng-template pTemplate="empty">
              <div class="flex align-items-center justify-content-center flex-column">
                <i class="pi pi-cloud-upload"></i>
                <p class="mt-4 mb-0">{{'import-service-order.drag-drop' | translate}}</p>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <p-tag *ngIf="messageUpload != ''" [severity]="messageSeverity" [value]="messageUpload" />
            </ng-template>
          </p-fileUpload>
        </p-card>
        <p-card header="{{'import-service-order.resources' | translate}}">
          <div class="template-actions">
            <button pButton icon="pi pi-download" class="p-button-rounded btn-send-file"
              label="{{'import-service-order.download-model-button' | translate}}" (click)="downloadCsvFile()">
            </button>
          </div>
        </p-card>
      </div>
    </div>

    <!-- Editable rows table -->
    <div *ngIf="csvModel === 'editable'" class="editable-section">
      <p-card>

        <div class="editable-topbar">
          <span class="editable-card-title">Ordens de Serviço</span>
          <span class="file-badge">
            <i class="pi pi-file-excel"></i>
            <span class="file-badge-name">{{ file?.name }}</span>
            <i class="pi pi-times file-badge-close" (click)="onFileClear()" title="Remover arquivo"></i>
          </span>
          <!-- Só visível em viewport curta (<=900px), onde o card de título é escondido. -->
          <button pButton icon="pi pi-question-circle" class="p-button-rounded p-button-sm btn-send-file topbar-instructions"
            label="{{'import-service-order.see-instructions' | translate}}" (click)="visibleInstructions = true">
          </button>
        </div>

        <!-- Pending: awaiting user to start validation -->
        <div *ngIf="hasPendingRows() && !isValidating" class="validate-bar">
          <i class="pi pi-info-circle"></i>
          <span>{{ pendingRowsCount() }} {{ pendingRowsCount() === 1 ? 'linha aguarda' : 'linhas aguardam' }}
            verificação</span>
          <button pButton icon="pi pi-play" label="Iniciar Verificação"
            class="p-button-sm p-button-rounded btn-send-file" (click)="startValidation()">
          </button>
        </div>

        <!-- Validating: show progress + cancel -->
        <div *ngIf="isValidating" class="lookup-loading">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Verificando instalações... {{ validatedCount }}/{{ totalToValidate }}</span>
          <button class="cancel-validation-btn" (click)="cancelValidation()">
            <i class="pi pi-times"></i> Cancelar
          </button>
        </div>

        <!-- Bulk edit toolbar (shown when rows are selected) -->
        <div class="bulk-toolbar" *ngIf="selectedRows.length > 0">
          <span class="bulk-info">{{ selectedRows.length }} linha(s) selecionada(s)</span>
          <select [(ngModel)]="bulkPriority" class="priority-select">
            <option value="">— Prioridade —</option>
            <option value="HIGH">Alta</option>
            <option value="MEDIUM">Normal</option>
            <option value="LOW">Baixa</option>
          </select>
          <p-autoComplete [(ngModel)]="bulkUser" [suggestions]="filteredUsers" (completeMethod)="filterUsers($event)"
            optionLabel="username" [forceSelection]="true" placeholder="Responsável" styleClass="bulk-autocomplete"
            appendTo="body">
          </p-autoComplete>
          <button pButton icon="pi pi-check" label="Aplicar a seleção"
            class="p-button-sm p-button-rounded btn-send-file" (click)="applyBulkEdit()">
          </button>
          <button pButton icon="pi pi-trash" [label]="'Deletar (' + selectedRows.length + ')'"
            class="p-button-sm p-button-rounded btn-delete" matTooltip="Remove todas as linhas selecionadas"
            matTooltipPosition="above" (click)="deleteSelectedRows()">
          </button>
          <button pButton icon="pi pi-times" label="Cancelar"
            class="p-button-sm p-button-rounded p-button-text btn-send-file" (click)="selectedRows = []">
          </button>
        </div>

        <p-table [value]="serviceOrderRows" [(selection)]="selectedRows" selectionMode="multiple" dataKey="rowIndex"
          [rowHover]="true" styleClass="editable-table" [scrollable]="true" scrollHeight="flex">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>ID OS</th>
              <th>Instalação</th>
              <th>Defeitos Informados</th>
              <th>Obs. Call Center</th>
              <th style="width: 5rem">Validação</th>
              <th style="width: 9rem">Prioridade</th>
              <th style="width: 14rem">Responsável *</th>
              <th style="width: 7rem">Status Importação</th>
              <th style="width: 3rem"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-row>
            <tr [ngClass]="getRowClass(row)" [matTooltip]="getRowTooltip(row)" matTooltipPosition="above">
              <td>
                <p-tableCheckbox [value]="row" [disabled]="row.status === 'creating' || row.status === 'created'">
                </p-tableCheckbox>
              </td>
              <td>{{ row.osId }}</td>
              <td class="installation-ref-cell">
                <span *ngIf="row.status !== 'invalid'">{{ row.installationReference }}</span>
                <input *ngIf="row.status === 'invalid'" [(ngModel)]="row.installationReference"
                  (blur)="relookupRow(row)" class="installation-ref-edit-input" placeholder="Corrigir referência" />
              </td>
              <td class="text-cell" [title]="row.defeitosInformados">
                {{ row.defeitosInformados | slice:0:60 }}{{ row.defeitosInformados.length > 60 ? '...' :
                '' }}
              </td>
              <td class="text-cell" [title]="row.observacaoCC">
                {{ row.observacaoCC | slice:0:60 }}{{ row.observacaoCC.length > 60 ? '...' : '' }}
              </td>
              <td class="installation-cell">
                <i *ngIf="row.status === 'pending'" class="pi pi-clock status-icon status-pending"
                  title="Aguardando verificação"></i>
                <i *ngIf="row.status === 'loading'" class="pi pi-spin pi-spinner status-icon"></i>
                <i *ngIf="row.status === 'valid' || row.status === 'creating' || row.status === 'created' || row.status === 'error'"
                  class="pi pi-check-circle status-icon status-valid" title="Instalação encontrada"></i>
                <i *ngIf="row.status === 'invalid'" class="pi pi-times-circle status-icon status-invalid"
                  [title]="row.errorMessage || 'Instalação não encontrada'"></i>
              </td>
              <td>
                <select [(ngModel)]="row.priority" class="priority-select"
                  [attr.disabled]="(row.status === 'creating' || row.status === 'created') ? '' : null">
                  <option value="HIGH">Alta</option>
                  <option value="MEDIUM">Normal</option>
                  <option value="LOW">Baixa</option>
                </select>
              </td>
              <td class="user-cell">
                <p-autoComplete [(ngModel)]="row.assigneeUser" [suggestions]="filteredUsers"
                  (completeMethod)="filterUsers($event)" optionLabel="username" [forceSelection]="true"
                  [disabled]="row.status === 'creating' || row.status === 'created'"
                  placeholder="Responsável *" styleClass="user-autocomplete" appendTo="body">
                </p-autoComplete>
              </td>
              <td class="create-status-cell">
                <i *ngIf="row.status === 'creating'" class="pi pi-spin pi-spinner"></i>
                <i *ngIf="row.status === 'created'" class="pi pi-check status-valid"></i>
                <span *ngIf="row.status === 'error'" class="row-error-badge">
                  <i class="pi pi-exclamation-triangle status-error"></i>
                  <button pButton icon="pi pi-refresh" class="p-button-text p-button-sm retry-btn"
                    matTooltip="Tentar novamente" (click)="retryRow(row)">
                  </button>
                </span>
              </td>
              <td>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-sm btn-delete"
                  [disabled]="row.status === 'loading' || row.status === 'creating' || row.status === 'created'"
                  (click)="deleteRow(row)">
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10" style="text-align: center; padding: 2rem; color: #6b7280;">
                Nenhuma linha disponível.
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Undo delete notification -->
        <div *ngIf="lastDeletedBatch.length > 0" class="undo-row">
          <div class="undo-notification">
            <i class="pi pi-trash undo-icon"></i>
            <span class="undo-text" *ngIf="lastDeletedBatch.length === 1">
              Linha <strong>{{ lastDeletedBatch[0].installationReference || lastDeletedBatch[0].osId }}</strong> removida
            </span>
            <span class="undo-text" *ngIf="lastDeletedBatch.length > 1">
              <strong>{{ lastDeletedBatch.length }}</strong> linhas removidas
            </span>
            <button pButton icon="pi pi-undo" label="Desfazer" class="p-button-rounded p-button-sm undo-btn"
              (click)="undoDelete()">
            </button>
          </div>
        </div>

        <!-- Actions bar — footer unificado: 3 zonas
                     [esquerda: totais/válidas/inválidas] [centro: status criação] [direita: ação principal] -->
        <div class="actions-bar">
          <div class="rows-summary">
            <span class="summary-total-group" [class.summary-action-disabled]="serviceOrderRows.length === 0"
              title="Baixar CSV com todas as linhas" (click)="serviceOrderRows.length > 0 && downloadformatedCsv()">
              {{ serviceOrderRows.length }} {{ serviceOrderRows.length === 1 ? 'linha' : 'linhas' }} no
              total
              <i class="pi pi-download summary-action-icon"></i>
            </span>
            <span *ngIf="displayedValidCount() > 0" class="summary-valid summary-valid-group"
              [class.summary-action-disabled]="hasLoadingRows()"
              [title]="hasLoadingRows() ? 'Aguarde a validação terminar' : 'Baixar CSV das linhas válidas'"
              (click)="!hasLoadingRows() && downloadValidRows()">
              {{ displayedValidCount() }} {{ displayedValidCount() === 1 ? 'válida' : 'válidas' }}
              <i class="pi pi-download summary-action-icon"></i>
            </span>
            <span *ngIf="displayedInvalidCount() > 0" class="summary-invalid summary-invalid-group">
              <span class="summary-invalid-download" [class.summary-action-disabled]="hasLoadingRows()"
                [title]="hasLoadingRows() ? 'Aguarde a validação terminar' : 'Baixar inválidas como CSV'"
                (click)="!hasLoadingRows() && downloadInvalidRows()">
                {{ displayedInvalidCount() }} {{ displayedInvalidCount() === 1 ? 'inválida' : 'inválidas' }}
                <i class="pi pi-download summary-action-icon"></i>
              </span>
              <i class="pi pi-trash summary-action-icon"
                [class.summary-action-disabled]="hasLoadingRows() || isCreating || hasPartialResults()"
                [title]="hasLoadingRows() ? 'Aguarde a validação terminar' : (isCreating || hasPartialResults() ? 'Indisponível após início da criação' : 'Descartar todas as inválidas')"
                (click)="!hasLoadingRows() && !isCreating && !hasPartialResults() && discardInvalidRows()"></i>
            </span>
          </div>

          <!-- Zona central: progresso durante envio OU resumo do resultado por linha -->
          <div class="creation-status">
            <!-- Batch é um único request: sem progresso por linha, rótulo genérico -->
            <span *ngIf="isCreating" class="creation-progress">
              <i class="pi pi-spin pi-spinner"></i>
              Enviando lote...
            </span>
            <!-- Resumo do resultado (deriva do status por linha). Criadas e erros baixáveis. -->
            <ng-container *ngIf="!isCreating && hasPartialResults()">
              <span *ngIf="createdCount() > 0" class="summary-created summary-created-group"
                title="Baixar CSV das ordens criadas" (click)="downloadSuccessCsv()">
                {{ createdCount() }} {{ createdCount() === 1 ? 'criada' : 'criadas' }}
                <i class="pi pi-download summary-action-icon"></i>
              </span>
              <span *ngIf="errorCount() > 0" class="summary-error summary-error-group"
                title="Baixar log de erros" (click)="downloadErrorLog()">
                {{ errorCount() }} com erro
                <i class="pi pi-download summary-action-icon"></i>
              </span>
            </ng-container>
            <!-- Falha de envio/HTTP (ex.: 401): lote não enviado, linhas voltam a 'valid'.
                 Sem resultado por linha, então a mensagem de erro aparece aqui no footer. -->
            <span *ngIf="!isCreating && !hasPartialResults() && messageSeverity === 'danger'"
              class="summary-error creation-error">
              <i class="pi pi-exclamation-triangle"></i>
              {{ messageUpload }}
            </span>
          </div>

          <!-- Botão retry-all: reenvia ao batch só as linhas com erro. -->
          <button pButton icon="pi pi-refresh" label="Tentar erros novamente" class="p-button-rounded p-button-warning"
            *ngIf="failedRowsCount() > 0 && !isCreating"
            [matTooltip]="'Reprocessar ' + failedRowsCount() + ' linha(s) com erro'" (click)="retryAllErrors()">
          </button>

          <!-- Botão Criar. Batch é um POST único: enquanto envia fica "Criando..." desabilitado. -->
          <button pButton [icon]="isCreating ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
            [label]="isCreating ? 'Criando...' : 'Criar Ordens de Serviço'"
            class="p-button-rounded btn-send-file"
            [disabled]="isCreating || !canCreate()"
            [matTooltip]="!isCreating && !canCreate() ? 'Corrija todas as linhas inválidas e preencha todos os responsáveis' : ''"
            (click)="createAllServiceOrders()">
          </button>
        </div>

      </p-card>
    </div>

  </div>
</div>

<p-dialog header="{{'import-service-order.instructions-import-title' | translate}}" [modal]="true"
  [(visible)]="visibleInstructions" [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">

  <div class="steps-container">
    <h2> {{'import-service-order.screen-description' | translate}} </h2>
    <div class="step">
      <div>
        <p>
          {{'import-service-order.description' | translate}}
          <br><br>
          <b>{{'import-service-order.tip' | translate}}</b>
          {{'import-service-order.tip-description' | translate}}
        </p>
      </div>
    </div>

    <h2> {{'import-service-order.instructions-title' | translate}} </h2>

    <div class="step">
      <i class="pi pi-download"></i>
      <div>
        <strong>{{'import-service-order.download-csv-title' | translate }}</strong>
        <p>{{'import-service-order.download-csv-text' | translate }}</p>
      </div>
    </div>

    <div class="step">
      <i class="pi pi-file-edit"></i>
      <div>
        <strong>{{'import-service-order.fill-file-title' | translate}}</strong>
        <p>{{'import-service-order.fill-file-text' | translate}}</p>
      </div>
    </div>

    <div class="step">
      <i class="pi pi-save"></i>
      <div>
        <strong>{{'import-service-order.save-file-title' | translate}}</strong>
        <p> {{'import-service-order.save-file-text' | translate}}</p>
      </div>
    </div>

    <div class="step">
      <i class="pi pi-upload"></i>
      <div>
        <strong>{{'import-service-order.select-file-title' | translate}}</strong>
        <p>{{'import-service-order.select-file-text' | translate}}<b>{{'import-service-order.select-file' |
            translate}}</b>
          {{'import-service-order.choose-file' | translate}}</p>
      </div>
    </div>

    <div class="step">
      <i class="pi pi-play"></i>
      <div>
        <strong>{{'import-service-order.import-title' | translate}}</strong>
        <p> {{'import-service-order.import-text' | translate}} <b>{{'import-service-order.import' |
            translate}}</b>
          {{'import-service-order.start-processing' | translate}}
        </p>
      </div>
    </div>
    <div class="step">
      <i class="pi pi-check-circle"></i>
      <div>
        <strong>{{'import-service-order.follow-results-title' | translate}}</strong>
        <p>{{'import-service-order.follow-results-text' | translate}}</p>
        <ul>
          <li>{{'import-service-order.service-order-created' | translate}}</li>
          <li>{{'import-service-order.service-order-errors' | translate}}</li>
        </ul>
      </div>
    </div>
    <p-divider></p-divider>
    <div class="warning">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        {{'import-service-order.warning-text' | translate}}
      </span>
    </div>
  </div>
</p-dialog>